import { createAction } from '@reduxjs/toolkit';
import type { ListFeedbackStatus } from '@shared/constants/list-feedback-status';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on (#717).
 * Kept out of the slice's reducers: they trigger side effects, not state
 * transitions.
 */

/** Load every feedback (dispatched by the page on mount). */
export const feedbacksRequested = createAction('listFeedbacks/feedbacksRequested');

/**
 * Refresh the sidebar badge. Dispatched by the SideNav on every admin route
 * change, and by the saga after a status change.
 */
export const openCountRequested = createAction('listFeedbacks/openCountRequested');

/** Move one feedback to another status, from the side panel. */
export const statusChangeRequested = createAction<{ id: string; status: ListFeedbackStatus }>(
  'listFeedbacks/statusChangeRequested',
);
